import { render, staticRenderFns } from "./NewsHome.vue?vue&type=template&id=e6771c12&scoped=true&"
import script from "./NewsHome.vue?vue&type=script&lang=js&"
export * from "./NewsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6771c12",
  null
  
)

export default component.exports